module.exports = __webpack_public_path__ + "img/map.062a93e2.png";